import React, {useContext, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Checkbox, Input, Modal, Tooltip} from "antd";
import Colors from "../../../styles/Colors";
import {BsDatabaseFill, BsFilePdf} from "react-icons/bs";
import {QuestionCircleOutlined} from "@ant-design/icons";
import toast, {Toaster} from "react-hot-toast";
import Historials from "../../components/Historials";
import {
    CheckRemesaVolcada,
    DescarregarPdfFacturacio,
    DescarregarPdfLoop,
    VolcarRemesa
} from "../../../dao/multilleure/administracio/GenerarPdf";

const GenerarPdf = () => {
    const titol = "Generar PDF de remesa";
    const {isLoggedIn, page, token} = useContext(AuthContext);

    // Bloc 1: remesa del loop
    const [idRemesaLoop, setIdRemesaLoop] = useState<string>("");
    const [retorn, setRetorn] = useState<boolean>(false);
    const [carregant, setCarregant] = useState<boolean>(false);
    const [descarregantLoop, setDescarregantLoop] = useState<boolean>(false);
    const [confirmVisible, setConfirmVisible] = useState<boolean>(false);

    // Bloc 2: remesa de facturacio
    const [idRemesaFact, setIdRemesaFact] = useState<string>("");
    const [descarregantFact, setDescarregantFact] = useState<boolean>(false);

    // ---- Bloc 1 ----
    async function carregarRemesa() {
        if (!idRemesaLoop.trim()) {
            toast.error("Introdueix l'id de remesa del loop");
            return;
        }
        setCarregant(true);
        try {
            const volcada = await CheckRemesaVolcada(idRemesaLoop.trim(), page, token);
            if (volcada) {
                setConfirmVisible(true);
            } else {
                await volcar();
            }
        } finally {
            setCarregant(false);
        }
    }

    async function volcar() {
        setCarregant(true);
        try {
            const res = await VolcarRemesa(idRemesaLoop.trim(), retorn, page, token);
            if (res.ok) toast.success(res.message || "Remesa volcada correctament");
            else toast.error(res.message || "Error al volcar la remesa");
        } finally {
            setCarregant(false);
        }
    }

    async function confirmarVolcat() {
        setConfirmVisible(false);
        await volcar();
    }

    async function descarregarLoop() {
        if (!idRemesaLoop.trim()) {
            toast.error("Introdueix l'id de remesa del loop");
            return;
        }
        setDescarregantLoop(true);
        try {
            const url = await DescarregarPdfLoop(idRemesaLoop.trim(), page, token);
            baixarFitxer(url, `rebuts_remesa_${idRemesaLoop.trim()}.pdf`);
        } finally {
            setDescarregantLoop(false);
        }
    }

    // ---- Bloc 2 ----
    async function descarregarFacturacio() {
        if (!idRemesaFact.trim()) {
            toast.error("Introdueix l'id de remesa");
            return;
        }
        setDescarregantFact(true);
        try {
            const url = await DescarregarPdfFacturacio(idRemesaFact.trim(), page, token);
            baixarFitxer(url, `rebuts_remesa_${idRemesaFact.trim()}.pdf`);
        } finally {
            setDescarregantFact(false);
        }
    }

    function baixarFitxer(url: string, nom: string) {
        if (url && url !== "") {
            const link = document.createElement('a');
            link.href = url;
            link.download = nom;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    if (!isLoggedIn) return <Login/>;

    return (
        <div>
            <Toaster/>
            <NavBar/>
            <div className="general">
                <Card bordered className="elemento">
                    <h4 className="titol" style={{marginBottom: 16}}>{titol}</h4>

                    {/* Bloc 1: remesa del loop */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap',
                            marginBottom: 16,
                            width: '100%',
                        }}>
                        <span>Id remesa loop:</span>
                        <Input
                            value={idRemesaLoop}
                            onChange={(e) => setIdRemesaLoop(e.target.value)}
                            style={{width: 160}}
                            placeholder="Ex: 1234"
                        />
                        <Checkbox
                            checked={retorn}
                            onChange={(e) => setRetorn(e.target.checked)}
                        >
                            Rebuts retornats
                        </Checkbox>
                        <Tooltip title="Carregar remesa (volcat des del loop)">
                            <Button
                                icon={<BsDatabaseFill/>}
                                loading={carregant}
                                style={{backgroundColor: Colors.colors.color1, color: '#fff'}}
                                onClick={carregarRemesa}
                            >
                                Carregar Remesa
                            </Button>
                        </Tooltip>
                        <Tooltip title="Descarregar PDF de la remesa volcada">
                            <Button
                                icon={<BsFilePdf/>}
                                loading={descarregantLoop}
                                style={{backgroundColor: Colors.colors.color4, color: '#fff'}}
                                onClick={descarregarLoop}
                            >
                                Descarregar PDF
                            </Button>
                        </Tooltip>
                    </div>

                    <hr/>

                    {/* Bloc 2: remesa de facturacio */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap',
                            marginTop: 16,
                            width: '100%',
                        }}>
                        <span>Id remesa:</span>
                        <Input
                            value={idRemesaFact}
                            onChange={(e) => setIdRemesaFact(e.target.value)}
                            style={{width: 160}}
                            placeholder="Ex: 1234"
                        />
                        <Tooltip title="Descarregar PDF des de facturació">
                            <Button
                                icon={<BsFilePdf/>}
                                loading={descarregantFact}
                                style={{backgroundColor: Colors.colors.color4, color: '#fff'}}
                                onClick={descarregarFacturacio}
                            >
                                Descarregar PDF
                            </Button>
                        </Tooltip>
                    </div>
                </Card>
                <br/>
                <Historials pantalla="GENERARPDF" pagina={page}/>
            </div>

            <Modal
                title={<span><QuestionCircleOutlined style={{color: 'orange', marginRight: 8}}/>Tornar a fer un volcat</span>}
                open={confirmVisible}
                onOk={confirmarVolcat}
                onCancel={() => setConfirmVisible(false)}
                okText="Acceptar"
                cancelText="Cancel·lar"
            >
                <p>Aquesta remesa ja està volcada. Vols eliminar-la i tornar-la a volcar?</p>
            </Modal>
        </div>
    );
};

export default GenerarPdf;
